import Vue from 'vue'
import { BASE_URL } from '~/const/base-url'

// method
async function post({ url, dispatchParams = {} }: { url: string; dispatchParams?: object }): Promise<any> {
    try {
        const { data } = await Vue.$axios({
            method: 'post',
            headers: { Authorization: '' },
            baseURL: BASE_URL,
            url: `/rest-auth/${url}/`,
            data: dispatchParams
        })
        return data
    } catch (err) {
        console.error(err)
        throw err
    }
}

export interface ILoginParams {
    email: string
    password: string
}

async function login(dispatchParams: ILoginParams): Promise<any> {
    return post({ url: 'login', dispatchParams })
}

async function facebookLogin(accessToken: string): Promise<any> {
    return post({ url: 'facebook', dispatchParams: { access_token: accessToken } })
}
async function googleLogin(accessToken: string): Promise<any> {
    return post({ url: 'google', dispatchParams: { access_token: accessToken } })
}

async function logout(): Promise<any> {
    return post({ url: 'logout' })
}

async function forgotPassword(email: string): Promise<any> {
    return post({ url: 'password/reset', dispatchParams: { email } })
}

interface IResetPasswordConfirmParams {
    uid: string
    token: string
    new_password1: string
    new_password2: string
}

async function resetPasswordConfirm(dispatchParams: IResetPasswordConfirmParams): Promise<any> {
    return post({ url: 'password/reset/confirm', dispatchParams })
}

async function confirmEmail(confirmKey: string): Promise<string> {
    return post({ url: 'registration/verify-email', dispatchParams: { key: confirmKey } })
}

export { login, facebookLogin, googleLogin, logout, forgotPassword, resetPasswordConfirm, confirmEmail }
